import React, { useEffect } from "react";
import { Provider, useDispatch, useSelector } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { ConfigProvider, Spin } from "antd";
import { createBrowserHistory, createHashHistory } from "history";
import configureStore from "./configureStore";
import locale from "antd/lib/locale/zh_CN";
import VhLazy from "components/vh-common/lazy/VhLazy";
import Tools from "utils/tools";
import "moment/locale/zh-cn";
import "./App.scss";
import { ApplicationState } from "store";
import { fetchGetProjectSetting } from "store/common/actions";
import { DOMAIN } from "common/constants";

const basename = "/";
/** 创建browser history对象，router和redux连接必须传递 */
const history = Tools.supportsHistory()
  ? createBrowserHistory({ basename })
  : createHashHistory({ basename });
/** 配置store */
const store = configureStore(history);
/** 组件加载时的内容 */
const fallback = <div className="entrying">正在加载页面...</div>;
/** 首页 */
const VhLayout = VhLazy(
  () => import("components/vh-layout/VhLayout"),
  fallback
);

/**
 * 根组件
 * 1、使用Provider提供redux state
 * 2、ConnectedRouter连接redux和router
 * 3、LocaleProvider提供antd中文设置
 * 4、加载首页组件
 * autoInsertSpaceInButton: 按钮文字中间空格去掉
 * locale: 国际化
 */
const mapState = ({ commonState }: ApplicationState) => ({
  /** 加载 */
  loading: commonState.loading,
});

// 内部组件，用于在Provider内部使用Redux hooks
const AppContent = () => {
  const { loading } = useSelector(mapState);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGetProjectSetting({ templateType: 10, domain: DOMAIN }));
  }, [dispatch]);

  return (
    <>
      {!loading.showB ? (
        <VhLayout />
      ) : (
        <Spin size="large" tip="正在加载页面..." />
      )}
    </>
  );
};

const App = () => {
  const config = {
    autoInsertSpaceInButton: false,
    locale,
  };

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ConfigProvider {...config}>
          <AppContent />
        </ConfigProvider>
      </ConnectedRouter>
    </Provider>
  );
};

export default App;
